export default __webpack_public_path__ + "static/media/CNo.82-1.4fdc3e59.jpg";